module.exports = __webpack_public_path__ + "landing_static/img/header-md-t.ee762964.png";